import Axios from "../axios/axios";
import {
  ORDER_CREATE_REQUEST,
  ORDER_CREATE_SUCCESS,
  ORDER_CREATE_FAIL,
  ORDER_LIST_FAIL,
  ORDER_LIST_SUCCESS,
  ORDER_LIST_REQUEST,
  ORDER_DELETE_REQUEST,
  ORDER_DELETE_SUCCESS,
  ORDER_DELETE_FAIL,
} from "../constants/orderConstant";

export const orderNow = (data) => async (dispatch, getState) => {
  try {
    dispatch({
      type: ORDER_CREATE_REQUEST,
    });

    const { data_ } = await Axios.post(`/api/order/`, data);

    return data_;

    // dispatch({
    //   type: ORDER_CREATE_SUCCESS,
    //   payload: data_,
    // });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    // if (message === 'Not authorized, token failed') {
    //   dispatch(logout());
    // }
    dispatch({
      type: ORDER_CREATE_FAIL,
      payload: message,
    });
  }
};

export const listOrder = async(data_)   => {
  try {

    const { data } = await Axios.post(`/api/order/list`, data_);
    console.log(data)
    console.log(data_)

    return data
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;

 
  }
};

// // No redux-style (no dispatch or getState)
// export const listOrder = async ({page} ) => {
//   console.log(page)
//   try {
//     const { data } = await Axios.post(`/api/order/list`, {page});
//     return data;
//   } catch (error) {
//     console.error(error.response?.data?.message || error.message);
//     return [];
//   }
// };

export const deleteOrder = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: ORDER_DELETE_REQUEST,
    });

    await Axios.post(`/api/order/delete/admin/${id}`);

    dispatch({
      type: ORDER_DELETE_SUCCESS,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    // if (message === 'Not authorized, token failed') {
    //   dispatch(logout());
    // }
    dispatch({
      type: ORDER_DELETE_FAIL,
      payload: message,
    });
  }
};
